import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// Keystone Crystals (b_at4bwf6pjp, advertiser 8216023487244339574).
// Lifetime complete-month metrics through Aug 2026.
export const advKeystoneCrystals: FaireAdvertiserProfileEntity = {
  token: "adv_keystone_crystals",
  type: "advertiserProfile",
  archetype: "new-and-returning",
  displayName: "Keystone Crystals",
  brandToken: "b_at4bwf6pjp",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 25,
  budget: {
    totalBudgetDollars: 2222,
    sharedBudgetDollars: 2222,
    spendingMode: "MODERATE",
    nextRenewsAtDate: "2026-10-01",
    nextBillsAtDate: "2026-10-04",
  },
  overview: {
    numCustomersAcquired: 232,
    numReorderConversions: 201,
    numTotalConversions: 433,
    totalAdsSalesDollars: 173816,
    newCustomerAdsSalesDollars: 107986,
    reorderAdsSalesDollars: 65830,
    totalAdsSpendDollars: 20859,
    newCustomerAdsSpendDollars: 14918,
    reorderAdsSpendDollars: 5941,
    newCustomerBestEstimateFirstYearRoas: 7.6,
    reorderRoas: 11.08,
    combinedFirstYearRoas: 8.59,
    numNewCustomerAdsOrders: 467,
    numReorderAdsOrders: 244,
  },
  availableCredit: { totalRemainingDollars: 0 },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 1270,
      maxRecommendedBudgetDollars: 2540,
      isEligibleForIncreaseRec: false,
    },
    reorder: {
      minRecommendedBudgetDollars: 800,
      maxRecommendedBudgetDollars: 1600,
      isEligibleForIncreaseRec: false,
    },
  },
  campaignTokens: ["camp_kcr_new", "camp_kcr_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
